import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';
import { TextDesktop as Text } from '@alfa-bank/site-text-v2/desktop';
import { Grid } from '@alfa-bank/site-grid-universal';
import { getSymbolForPrice } from '@alfa-bank/site-invest-emitents-common/helpers';
import {
    EMPTY_VALUE_TEXT,
    TITLE_LAST_PRICE,
} from '@alfa-bank/site-invest-emitents-common/constants';
import { HintDesktop as Hint } from '@alfa-bank/site-invest-mediaportal-common/components/hint-desktop';
import { PriceRenderer } from '@alfa-bank/site-invest-emitents-common/components/renderer';

import styles from '../styles/desktop.css';
import type { TPrice } from '../models';

import { HintPriceContentDesktop as HintPriceContent } from './hint-content/desktop';

export const PriceDesktop: FC<TPrice> = ({ asset }) => {
    const { assetType, currency, lastPrice } = asset;

    const symbol = getSymbolForPrice({ assetType: assetType.code, symbol: currency.symbol });

    return (
        <>
            <Grid
                alignment="center"
                colAutoWidth
                collapse
                columnsMargin={4}
                justify="start"
                styler={{ marginBottom: 8 }}
            >
                <Text
                    className={cn(styles.external, styles.nowrap)}
                    kind="secondary"
                    styler={{ margin: 0 }}
                    view="primary-small"
                >
                    {TITLE_LAST_PRICE}
                </Text>
                <Hint
                    content={<HintPriceContent assetTypeCode={assetType.code} />}
                    iconClassName={cn(styles.external, styles.hintIcon)}
                    restrictPopoverWidth={false}
                />
            </Grid>
            <Text styler={{ margin: 0 }} view="xsmall">
                <PriceRenderer fallbackValue={EMPTY_VALUE_TEXT} symbol={symbol} value={lastPrice} />
            </Text>
        </>
    );
};
